import { render, staticRenderFns } from "./common-partners.vue?vue&type=template&id=f39439dc&scoped=true"
import script from "./common-partners.vue?vue&type=script&lang=js"
export * from "./common-partners.vue?vue&type=script&lang=js"
import style0 from "./common-partners.vue?vue&type=style&index=0&id=f39439dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f39439dc",
  null
  
)

export default component.exports